import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "TEDxBled pitch",
  "description": "",
  "published": "2012-02-02T00:00:00.000Z",
  "redirect_from": ["/blog/tedxbled-pitch/swizec/3621"],
  "categories": "Self-organization, TED, TEDx, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><a parentName="p" {...{
        "href": "https://www.facebook.com/TEDxBled"
      }}>{`TEDxBled`}</a>{` is right around the corner and it's accepting random people to come give a talk. There's a competition going on and out of everyone who submits a video they'll pick the best two to come dazzle the audience.`}</p>
    <p>{`Since this is a pretty cool opportunity and I almost have something worthwhile to say I decided to pitch a talk about my `}<a parentName="p" {...{
        "href": "http://swizec.com/blog/a-message-from-your-future-self/swizec/3377",
        "title": "A message from your future self"
      }}>{`giving your future self a voice`}</a>{` idea. It's nowhere near the high level of altruism and awesomeness of `}<a parentName="p" {...{
        "href": "http://challengefuture.org/quick/32"
      }}>{`the other ideas pitched so far`}</a>{`, but hey ... we can't all be spectacular right?`}</p>
    <p>{`Talking into a computer is insanely weird for me, I prefer a crowd - it's somehow easier, probably because I can feel for a connection, get a few cheap laughs and generally feel how I'm doing and whether I should change the pace around or whatever.`}</p>
    <p>{`After a few takes I came up with this:`}</p>
    <lite-youtube {...{
      "videoid": "CZKWoS90xC0",
      "videostartat": "0"
    }}></lite-youtube>
    <p>{`The voice is crappy, the lighting sucks because you can't see my face well, but if I tried going for a different shot I'd have to clean my room and that just sounds too much like an excuse to avoid studying for exams.`}</p>
    <p>{`It's a long shot and I probably won't be asked to present, but at least I tried :)`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://swizec.com/blog/tedxyouth-ljubljana-report/swizec/3039"
        }}>{`TEDxYouth Ljubljana report`}</a>{` (swizec.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://mumbrella.com.au/tedx-speaker-auditions-to-come-to-sydney-but-no-product-hawkers-jargon-junkies-dullards-motivator-wannabes-spouters-of-new-age-fluff-72768"
        }}>{`TEDx speaker auditions to come to Sydney - but no product-hawkers, jargon-junkies, dullards, motivator wannabes or spouters of new-age fluff`}</a>{` (mumbrella.com.au)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://meinewalt.wordpress.com/2011/11/16/tedx-coming-to-nagpur/"
        }}>{`TEDx coming to Nagpur`}</a>{` (meinewalt.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://midd-blog.com/2011/11/05/tedx-2011-embracing-risk/"
        }}>{`TEDx 2011: Embracing Risk (Live-Blog)`}</a>{` (midd-blog.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=55ac8aa5-50b2-4b06-99b1-f3dfd328a345",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      